<template>
  <div class="editpass">
    <mt-header title="修改登录密码" class="reftitle">
      <mt-button slot="left" icon="back" @click="goback">返回</mt-button>
    </mt-header>
    <div class="editpasscont">
      <mt-field label="原密码" placeholder="请输入原密码" type="password" v-model="oldpassword"></mt-field>
      <mt-field label="新密码" placeholder="请输入新密码" type="password" v-model="password"></mt-field>
      <mt-field label="确认密码" placeholder="请确认新密码" type="password" v-model="password1"></mt-field>
    </div>
    <div class="editpasscont yzmposition">
      <mt-field label="验证码" placeholder="请确认验证码" type="number" v-model="mobileCode"></mt-field>
      <div class="yzmdiv">
        <button class="fr codebtn" :class="{cliac:flag}" @click="getCode()" v-bind:disabled="flag">{{codeValue}}
        </button>
      </div>
    </div>
    <div class="epbtdiv">
      <mt-button class="login-btn" size="large" type="primary" @click="sure()">保&nbsp;&nbsp;存</mt-button>
    </div>
  </div>
</template>

<script>
  import cheader from '@/components/header';
  import {Toast} from 'mint-ui';
  export default {
    data () {
      return {
        count: 60,
        codeValue: '获取验证码',
        flag: false,
        outTimer: '',
        mobileType: 5,  // 修改密码验证码,
        mobileCode: "",
        oldpassword: "",
        password: "",
        password1: ""
      }
    },
    methods: {
      goback: function () {
        history.go(-1); //后退1页
      },
      valiateData: function () {
        if (this.oldpassword == "") {
          this.$toast('原密码不可以为空');
          return false;
        }
        if (this.password == "") {
          this.$toast('新密码不可以为空');
          return false;
        }
        var reg = /^(\w){6,20}$/;
        if (!reg.test(this.password)) {
          Toast("密码长度为6到20位之间,只能包含字符、数字和下划线");
          return false;
        }
        if (this.password1 != this.password) {
          this.$toast('两次密码输入不一致');
          return false;
        }
        if (this.mobileCode == "") {
          this.$toast('验证码不可以为空.');
          return false;
        }
        return true;
      },
      sure: function () {
        var flag = this.valiateData();
        if (!flag) {
          return;
        }
        this.$http.post(
          domain("_editUserPassword"), {
            mobileType: this.mobileType,
            mobileCode: this.mobileCode,
            password: $.md5(this.password),
            oldpassword: $.md5(this.oldpassword)
          },
          {emulateJSON: true}
          )
          .then(function (response) {
              //接口返回数据
              var code = response.data.code;
              var msg = response.data.msg;
              if (code == "0") {
                this.$toast('修改成功,请重新登录');
                var ticketId = localStorage.getItem("ticketId");
                localStorage.removeItem("ticketId");
                this.$http.post(
                    domain("_logoutUrl") + "?ticketId=" + ticketId
                  )
                  .then(function (response) {
                    this.$router.push({
                      path: '/'
                    })
                  }, function (error) {
                    console.log(error);
                  })
              } else {
                this.$toast(msg);
              }
            }, function (error) {
              console.log(error)
              //Toast("数据获取响应异常.")
            }
          )
      },
      getCode: function () {
        this.$http.post(
          domain("_getyzmUrl"), {
            mobileType: this.mobileType
          },
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            if (response.body.code == '0') {
              this.$toast('验证码已发送,请查收');
              this.settime();
            } else {
              this.$toast('获取验证码失败,请稍后重试');
            }
          }, function (error) {
          })
      }
      ,
      settime: function () {
        var that = this;
        if (this.count == 0) {
          this.count = 60;
          this.flag = false;
          this.codeValue = '获取验证码';
          if (this.outTimer != null) {
            this.outTimer = null;
            return;
          }
        }
        this.flag = true;
        this.count--;
        this.codeValue = "重新发送(" + this.count + "s)";
        this.outTimer = setTimeout(function () {
          that.settime()
        }, 1000);
      }
    },
    components: {
      cheader
    }
  }
</script>
<style>
  .editpass {
    height: 100%;
    background-color: #f0f0f0;
  }

  .editpasscont {
    margin: 15px 0;
  }

  .editpasscont .mint-cell-text {
    color: #7d7d7d;
  }

  .epbtdiv {
    padding: 0 10px;
  }

  .editpass .mint-cell-wrapper, .editpass .mint-cell:last-child {
    background-size: 100% 1px;
  }

  .editpass .mint-cell-title {
    width: 75px;
  }

  .editpass .yzmdiv {
    width: 100%;
    height: 20px;
    position: relative;
  }

  .codebtn {
    display: block;
    cursor: pointer;
    color: #1f74d8;
    position: absolute;
    z-index: 2;
    width: 95px;
    height: 47px;
    top: -47px;
    left: 100%;
    margin-left: -102px;
    text-align: center;
    border: 0;
    background-color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/module/my/EditPass.vue